/* eslint-disable no-prototype-builtins */
import { Typography, useSize } from '../..';
import { capitalize, lowerCase } from 'lodash';
import { useCardTable } from './Context';
import React, { Fragment } from 'react';
export const CardTableDataCol = ({ name, children }) => {
    const { hiddenColumns } = useCardTable();
    const { size } = useSize();
    const currentColDef = hiddenColumns.find(col => col.name === name);
    const label = currentColDef && currentColDef.label;
    const isLabelHidden = currentColDef && currentColDef.isLabelHidden;
    return (React.createElement(Fragment, null,
        size !== 'small' && (React.createElement(Typography, { variant: "caption", color: "textSecondary", fontWeight: "light" }, isLabelHidden ? null : label || capitalize(lowerCase(name)))),
        children));
};
//# sourceMappingURL=CardTableDataCol.js.map